import { QUERY_JOB_BY_SLUG, QUERY_JOBS } from "../queries/jobs";
import { QUERY_PROJECT_TAGS, QUERY_PROJECTS } from "../queries/projects";
import { QUERY_TEAM_MEMBERS } from "../queries/team";
import { QUERY_ALL_PRESS } from "../queries/press";
export const QUERY_ENDPOINTS = {
  GET_PROJECT_TAGS: QUERY_PROJECT_TAGS,
  GET_PROJECTS: QUERY_PROJECTS,
  QUERY_TEAM_MEMBERS: QUERY_TEAM_MEMBERS,
  ALL_JOBS: QUERY_JOBS,
  JOB_BY_SLUG: QUERY_JOB_BY_SLUG,
  QUERY_ALL_PRESS: QUERY_ALL_PRESS,
};
